package org.example.project.model

enum class BattlePhase {
    WAITING_FOR_TARGET,
    QUESTION_ACTIVE,
    ATTACK_RESOLVING,
    PENALTY
}